import { Currency } from "@/types";

export interface PriceChartCurrency {
  code: Currency
  name: string
}

export interface PriceChartCryptoCurrency extends PriceChartCurrency {
  slug: string;
  ws: boolean;
}

export interface CryptoMarketInformation {
  code: Currency;
  market: string;
  price: number;
  chg24h: number;
  mktcap: number;
  volume24h: number;
  high24h: number;
  supply: number;
}

export interface PriceChartProps {
  cryptoCurrency: PriceChartCryptoCurrency;
  fiatCurrency: PriceChartCurrency;
  marketInformation: CryptoMarketInformation
}

export const enum ChartTimePeriod {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  THREE_MONTHS = 'three_months',
  SIX_MONTHS = 'six_months',
  YEAR = 'year',
  THREE_YEARS = 'three_years',
}

export interface ChartDataPoint {
  date: string;
  price: number;
}